import OSS from 'ali-oss'

/**
 * @param {File} file - 要上傳的檔案
 * @param {Object} sts - 從後端取得的 STS 資訊
 * @param {Function} onProgress - 上傳進度回呼 (可選)
 */
export async function uploadMultipartFile(file, sts, onProgress) {
  const client = new OSS({
    region: sts.region || 'oss-cn-hangzhou',
    accessKeyId: sts.accessKeyId,
    accessKeySecret: sts.accessKeySecret,
    stsToken: sts.securityToken,
    bucket: sts.bucket,
    endpoint: sts.endpoint,
    cname: true,
    secure: true,
  })

  const objectKey = sts.key // 通常是你生成的 oss 上的完整檔名

  const result = await client.multipartUpload(objectKey, file, {
    parallel: 4,
    partSize: 1024 * 1024 * 1,
    mime: file.type,
    headers: {
      'x-oss-callback': sts.callback ? Base64.encode(JSON.stringify(sts.callback)) : undefined,
    },
    progress: (percent) => {
      if (onProgress) onProgress(percent)
    },
  })
  return result
}

// base64 工具
const Base64 = {
  encode(str) {
    return btoa(unescape(encodeURIComponent(str)))
  }
}
